import { Row } from "antd";
import { comemosTodos26 } from "./assets/images";

const Closed = () => {
  return (
    // <div className="closed">
    // <h1>Sorry, we are closed</h1>
    // </div>
    <Row justify={"center"}>
      <img
        alt=""
        src={comemosTodos26}
        style={{
          maxWidth: "100%",
        }}
      />
      <h3>
        El plazo para participar en la convocatoria de renovaciones del programa{" "}
        <b>Comemos Tod@s 2026</b> ha finalizado. Agradecemos tu interés.
      </h3>
    </Row>
  );
};

export default Closed;
